/**
 *
 * @returns {RegExp}
 */
export function getPasswordRegex(): RegExp {
  return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[~!@#$%^&*_\-+=`|(){}\[\]:;"'<>,.?\/]).*$/;
}
